import React from 'react';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
const pains = ['Domingo buscando actividades que nunca quedan bien para tu sala real', 'Planificaciones para dirección armadas la noche anterior, a las corridas', 'Siempre las mismas propuestas porque no tenés un banco de secuencias serio', 'Las efemérides, los actos, los informes — sin sistema claro ni guion', 'Salas con niños en distintos momentos del desarrollo sin material diferenciado', 'Fin de semana agotado, domingo volvés a empezar el mismo ciclo'];
export const PainSection: React.FC = () => {
  return <Section data-id="element-196">
      <div className="max-w-3xl mx-auto" data-id="element-197">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-8" data-id="element-198">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <div className="text-lg md:text-xl text-gray-300 mb-10 space-y-4 text-center" data-id="element-199">
          <p data-id="element-200">
            Sos docente de Nivel Inicial. Amás lo que hacés. Pero nadie te dijo
            que ibas a pasar los domingos buscando actividades que no encajan,
            armando planificaciones a la noche y llegando al lunes con material
            que "más o menos sirve".
          </p>
          <p className="font-bold text-white" data-id="element-201">
            No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <div className="bg-red-500/10 border border-red-500/40 rounded-3xl p-6 md:p-10 mb-10" data-id="element-202">
          <ul className="space-y-6" data-id="element-203">
            {pains.map((pain, i) => <li key={i} className="flex items-start gap-4" data-id="element-204">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full text-red-500 shrink-0" data-id="element-205">
                  <X size={20} strokeWidth={3} data-id="element-206" />
                </div>
                <span className="text-lg text-white font-medium" data-id="element-207">{pain}</span>
              </li>)}
          </ul>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-brand-green text-center" data-id="element-208">
          ¿Y si este fuera el último domingo que pasás así?
        </h3>
      </div>
    </Section>;
};